var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.737 16.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#428bca;stroke-width:0.6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.693 -4.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.087,5.158A.3.3,0,0,0,21.821,5H7.3a.3.3,0,0,0-.254.466l5.4,8.394v7.17a.3.3,0,0,0,.187.279.3.3,0,0,0,.116.023.3.3,0,0,0,.214-.089l3.63-3.63a.3.3,0,0,0,.089-.214V13.861l5.4-8.394A.3.3,0,0,0,22.087,5.158Zm-5.964,8.45a.3.3,0,0,0-.048.164v3.5L13.049,20.3V13.772A.3.3,0,0,0,13,13.608l-5.145-8h13.41Z",
    transform: "translate(-7 -5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ef9e3db0ad489a01eec00ff5232c67e3.svg";
export { ForwardRef as ReactComponent };